const CircleLoaderFillLargeSvg = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="loader"
  >
    <rect x="4" y="4" width="32" height="32" rx="16" stroke="#F2F4F7" strokeWidth="8" />
    <path
      d="M35.9124 18.3275C36.2655 21.6879 35.5458 25.0738 33.8564 28C32.167 30.9262 29.5945 33.2424 26.5078 34.6167"
      stroke="#1369E9"
      strokeWidth="8"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="spinner-bg-overlay"
    />
  </svg>
);
export default CircleLoaderFillLargeSvg;
